export default __webpack_public_path__ + "static/media/Logo-circle.1d70bd74.png";